import { render, staticRenderFns } from "./PersonTransactionProfileDownload.vue?vue&type=template&id=0b417cd1&scoped=true&"
import script from "./PersonTransactionProfileDownload.vue?vue&type=script&lang=js&"
export * from "./PersonTransactionProfileDownload.vue?vue&type=script&lang=js&"
import style0 from "./PersonTransactionProfileDownload.vue?vue&type=style&index=0&id=0b417cd1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b417cd1",
  null
  
)

export default component.exports